<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Transplant Details
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="transplantType"
              disabled
              label="Transplant Type"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartDate"
              disabled
              label="Transplant Start Date"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartTime"
              disabled
              label="Transplant Start Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdDateLeftKidney"
              disabled
              label="Removed from Cold Date - Left Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidney"
              disabled
              label="Removed from Cold Time - Left Kidney"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantColdDateRightKidney"
              disabled
              label="Removed from Cold Date - Right Kidney"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="transplantColdTimeRightKidney"
              disabled
              label="Removed from Cold Time - Right Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateLeftKidney"
              disabled
              label="Clamp Removal Date - Left Kidney"
            />
          </div>


          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeLeftKidney"
              disabled
              label="Clamp Removal Time - Left Kidney"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateRightKidney"
              disabled
              label="Clamp Removal Date - Right Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="rewardTimeLeftKidney"
              disabled
              label="Rewarm Time - Left Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="rewardTimeRightKidney"
              disabled
              label="Rewarm Time - Right Kidney"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="coldIschemicTimeLeftKidney"
              disabled
              label="Cold Ischemic Time (CIT) - Left Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="coldIschemicTimeRightKidney"
              disabled
              label="Cold Ischemic Time (CIT) - Right Kidney"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="vesselUsed"
              disabled
              label="Vessel Used"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>

export default {
  name: "TransplantSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      transplantType: this.getTransplantType( this.patientBundle ),
      transplantStartDate: this.getTransplantStartDate( this.patientBundle ),
      transplantStartTime: this.getTransplantStartTime( this.patientBundle ),
      transplantColdDateLeftKidney: this.getTransplantColdDateLeftKidney( this.patientBundle ),
      transplantColdTimeLeftKidney: this.getTransplantColdTimeLeftKidney( this.patientBundle ),
      transplantColdDateRightKidney: this.getTransplantColdDateLeftKidney( this.patientBundle ),
      transplantColdTimeRightKidney: this.getTransplantColdTimeLeftKidney( this.patientBundle ),
      clampRemovalDateLeftKidney: this.getClampRemovalDateLeftKidney( this.patientBundle ),
      clampRemovalTimeLeftKidney: this.getClampRemovalDateLeftKidney( this.patientBundle ),
      clampRemovalDateRightKidney: this.getClampRemovalDateLeftKidney( this.patientBundle ),
      clampRemovalTimeRightKidney: this.getClampRemovalDateLeftKidney( this.patientBundle ),
      rewardTimeLeftKidney: this.getRewardTimeLeftKidney( this.patientBundle ),
      rewardTimeRightKidney: this.getRewardTimeLeftKidney( this.patientBundle ),
      coldIschemicTimeLeftKidney: this.getColdIschemicTimeLeftKidney( this.patientBundle ),
      coldIschemicTimeRightKidney: this.getColdIschemicTimeLeftKidney( this.patientBundle ),
      vesselUsed: this.getVesselUsed( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getTransplantType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#395' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueString;
      } 
      }
    },
    getTransplantStartDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#16533' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getTransplantStartTime( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#16533' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getTransplantColdDateLeftKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#396' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getTransplantColdTimeLeftKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#396' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getTransplantColdDateRightKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#396' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getTransplantColdTimeRightKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#396' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getClampRemovalDateLeftKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#397' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueDateTime.substring( 0,10 );
      } 
      }
    },
    getRewardTimeLeftKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#123' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueString;
      } 
      }
    },
    getColdIschemicTimeLeftKidney( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#121' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueString;
      } 
      }
    },
    getVesselUsed( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( n.resource?.category[ 0 ].coding[ 0 ].code === 'smartdata' && n.resource?.code.coding[ 0 ].code === 'TXP#126' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ]?.resource.code.text ) {
        return recipientStatus[ 0 ].resource.component[ 0 ].valueBoolean ? 'Yes' : 'No';
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 560px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
